import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { Action } from 'redux';
import { Observable } from 'rxjs';
import { LIST_CATEGORIES_SUCCESS } from '@webapp/store/categories/actions';
import { ListCategoriesSuccess } from '@webapp/store/categories/action-creators';
import { UpdateField } from '../action-creators';
import { filterSupportedPlatforms } from '../selector';

export const updateDSPsFromCategoriesEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ListCategoriesSuccess>(LIST_CATEGORIES_SUCCESS),
    filter((action) => action.contentType === 'platform'),
    map(
      (action) =>
        new UpdateField(
          'dsps',
          filterSupportedPlatforms(action.categories).map((c) => c.metadata.id)
        )
    )
  );
